/**
 * Status color mapping for purchase requisition/order statuses
 * Based on Figma prototype design system
 */

export type ExtendedOrderStatus =
  | 'Pending'
  | 'Pending Action Facility Log'
  | 'Pending XO/Approving Official Signature'
  | 'Pending CDD action/feedback'
  | 'Pending RIC/KO/Natick'
  | 'On Order'
  | 'Partial'
  | 'Partially Received'
  | 'Completed/Received'
  | 'Completed'
  | 'Contract awarded'
  | 'Natick/MIPR completed'
  | 'Cancelled';

export const getStatusColor = (status: string): string => {
  const statusLower = status.toLowerCase();

  // Completed states - Green
  if (
    statusLower.includes('completed') ||
    statusLower.includes('received') ||
    status === 'Natick/MIPR completed'
  ) {
    return 'success.dark';
  }

  // Partial/In Progress - Yellow/Amber
  if (statusLower.includes('partial')) {
    return 'warning.main';
  }

  // On Order/Contract awarded - Blue
  if (statusLower.includes('on order') || statusLower.includes('contract awarded')) {
    return 'info.main';
  }

  // Pending Action states - Orange
  if (
    statusLower.includes('pending action') ||
    statusLower.includes('pending xo') ||
    statusLower.includes('pending cdd') ||
    statusLower.includes('pending ric')
  ) {
    return 'warning.dark';
  }

  // Cancelled - Grey
  if (statusLower.includes('cancelled')) {
    return 'grey.600';
  }

  // Default Pending - Grey
  return 'grey.500';
};

export const getStatusChipProps = (status: string): { color: string; backgroundColor: string } => {
  return {
    color: 'common.white',
    backgroundColor: getStatusColor(status),
  };
};
